export default __webpack_public_path__ + "static/media/pointer.76773db6.png";